module.exports = striptags;